export const MP_NOTIFICATION_LIST = 'MP_NOTIFICATION_LIST';
export const MP_REQUESTED_BY = 'MP_REQUESTED_BY';
export const NEW_NOTIFICATIONS = 'NEW_NOTIFICATIONS';
export const CURRENT_NOTIFICATION = 'CURRENT_NOTIFICATION';
export const DECREMENT_NEW_NOTIFS_COUNT = 'DECREMENT_NEW_NOTIFS_COUNT';
export const UNREAD_NOTIFICATIONS = 'UNREAD_NOTIFICATIONS';
// export const SEARCHED_NOTIFICATIONS = 'SEARCHED_NOTIFICATIONS';
